import { ITrackEntry, Spine } from "pixi-spine";
import { Point, shuffle } from "../../MyHelpers";
import { FamilyConstructiveFeature } from "./FamilyConstructiveFeature";
import { FillingPotParams } from "./FillinPotParams";
import { ISpineTrackAnimation } from "./IGenericFamilySpine";
import { IFillingPotIncrements } from "./IFillingPotIncrement";
import { BetConfig, SlotGameBet } from "../../api";
import { PotCollectPosition } from "./CollectSRAPathFillingPot";

export class FamilyConstructivePotPoppet extends FamilyConstructiveFeature {
    public override SetDataPostionPotGlobal(potCollectPosition: PotCollectPosition[]) {
        //throw new Error("Method not implemented.");
    }
    public override GetDataPositionPot(): PotCollectPosition[] {
        //throw new Error("Method not implemented.");
        return null
    }
    
    // public override ReelStops(winSymbolsReelStop : string[]): void {
    //     //throw new Error("Method not implemented.");
    // }

    constructor(familyName: string, params: FillingPotParams, controlScalePoint: Point ) {
        super(familyName, params, controlScalePoint);
    }

    protected override SetAnimationIndex() {

        this.trackIndexAnimSpecialGameConnected = 0;
        this.spineHit.state.data.skeletonData.animations.forEach((anim, index) => {

            let spineTrackAnimation: ISpineTrackAnimation = {
                trackAnimationIndex: 0,
                loopAnimation: false,
                soundTrack: null,
                duration: 0,
                animationName: "",
                isActive: false
            }


            //this.allAnimationArray.push(anim);
            if (anim.name.includes("animationCollectPath_")) {
                this.animationArrayCollect.push(anim.name);
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.trackAnimationIndex = index + this.collectStartTrackIndex;
            }

            else if (anim.name.includes("RA_")) {
              return
            }
            else if (anim.name.includes("BG_")) {
                this.animationArrayBackground.push(anim.name);
                spineTrackAnimation.loopAnimation = true;
                spineTrackAnimation.trackAnimationIndex = index + this.backgroundIndexAnim;
            }
            else if (anim.name.includes("IDLE_")) {
                this.animatioBreathName = anim.name;
                spineTrackAnimation.trackAnimationIndex = this.trackIndexIDLE;
                spineTrackAnimation.loopAnimation = true;
                spineTrackAnimation.animationName = anim.name;
                spineTrackAnimation.isActive = true;
            }

            else if (anim.name.includes("LevelStartHit")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitSound");
            }

            else if (anim.name.includes("LevelAnimation_Full_LevelStart")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitSound");
            }

            else if (anim.name.includes("Level_Full_Idle")) {
                //this.animatioBreathName = anim.name;
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = true;
                spineTrackAnimation.animationName = anim.name;
                spineTrackAnimation.isActive = true;
            }

            else if (anim.name.includes("LevelAnimation_Default")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = true;
            }

            else if (anim.name.includes("EXPECTATION")) {
                spineTrackAnimation.trackAnimationIndex = 1;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("spineAnticipation");
            }

            else if (anim.name.includes("BN_BONUS")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("collectHitBonus");
            }

            else if (anim.name.includes("BN_START")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                spineTrackAnimation.soundTrack = this.spineTrackMap.get("BN_START");
            }

            else if (anim.name.includes("_Loop")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = true;
            }

            else if (anim.name.includes("_LevelStar")) {
                spineTrackAnimation.trackAnimationIndex = this.trackIndexAnimSpecialGameConnected;
                spineTrackAnimation.loopAnimation = false;
                if (this.spineTrackMap.has(anim.name)) spineTrackAnimation.soundTrack = this.spineTrackMap.get(anim.name);
            }



            spineTrackAnimation.duration = anim.duration;
            spineTrackAnimation.animationName = anim.name;
            this.allAnimationMap.set(anim.name, spineTrackAnimation);
        });
    }

    protected override SetMixAnimation(mixAnimationDuration : number = 0.8) {
        super.SetMixAnimation(mixAnimationDuration );
        //Create Mix LevelsAnimation 
        //console.log("Mix-Animation:", this.allLevelAnimationGrouped);
        for (let indexLevel = 0; indexLevel < this.allLevelAnimationGrouped.length; indexLevel++) {
            if (this.allAnimationMap.has(this.animatioBreathName)) this.spineHit?.state.data.setMix(this.animatioBreathName, this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], mixAnimationDuration);
            if (this.allAnimationMap.has("LevelAnimation_Default")) this.spineHit?.state.data.setMix("LevelAnimation_Default", this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], mixAnimationDuration);
            if (this.allAnimationMap.has("LevelAnimation_Default")) this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], "LevelAnimation_Default", mixAnimationDuration);
            if (this.allAnimationMap.has("BN_BONUS")) this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], "BN_BONUS", mixAnimationDuration);
            if (this.allAnimationMap.has("BN_START")) this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], "BN_START", mixAnimationDuration);
            if (this.allAnimationMap.has("EXPECTATION")) this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], "EXPECTATION", mixAnimationDuration);            
            if (this.allAnimationMap.has("EXPECTATION")) this.spineHit?.state.data.setMix("EXPECTATION", this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0] , mixAnimationDuration);            
            
            if ((indexLevel + 1) < this.allLevelAnimationGrouped.length) return
            this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], this.allLevelAnimationGrouped[indexLevel + 1].levelStartAnims[0], mixAnimationDuration);
            if (this.allLevelAnimationGrouped[indexLevel].levelLoopAnims.length > 0) return
            this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelStartAnims[0], this.allLevelAnimationGrouped[indexLevel + 1].levelLoopAnims[0], mixAnimationDuration);
            if (this.allAnimationMap.has("EXPECTATION")) this.spineHit?.state.data.setMix("EXPECTATION", this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0] , mixAnimationDuration);
            if (this.allAnimationMap.has("EXPECTATION")) this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0], "EXPECTATION", mixAnimationDuration);
            this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0], this.allLevelAnimationGrouped[indexLevel + 1].levelStartAnims[0], mixAnimationDuration);
            this.spineHit?.state.data.setMix(this.allLevelAnimationGrouped[indexLevel].levelLoopAnims[0], this.allLevelAnimationGrouped[indexLevel + 1].levelLoopAnims[0], mixAnimationDuration);
        }
    }

    protected override ClearLastLevel() {
    }

    protected override ClearLevels() {
    }

    // public override RamclearFillingPot(selecteBet: SlotGameBet) {
    //     this.availableLevelPerBet.forEach((b) => {
    //         //await service.api.storageDeleteOne(`${this.gameName}_${this.potName}_${b.Bet.TotalBetCents.InCents}`);
    //         //console.log("LevelBackend:", apiResult);
    //         let betFind = this.availableLevelPerBet.find(lbet => lbet.TotalBet == b.TotalBet);
    //         if (betFind == null) return
    //         betFind.currentLevel = 0;
    //         betFind.currentSpin = 0;
    //     });

    //     //console.log("Ramclear:",this.availableLevelPerBet)
    //     //console.log(`Ramclear-FillingPotComplete-${this.gameName}-${this.potName}`);
    //     this.ClearLevels(); 
    //     //await this.ResetPoseSpine();
    //     this.SetBet(selecteBet);
    // }
}